export const MAX_DAYS_FOR_APPOINTMENTS = 7;
